<template>
      <div>
           <template v-if="data.state !== undefined && data.state !== null">
                <b-icon v-if="data.state == 2" icon="x-octagon" variant="danger" animation="throb" font-scale="8" />
                <b-icon v-if="data.state ==1" icon="check" variant="success" animation="throb" font-scale="8" />
                <b-icon v-if="data.state == 0" icon="exclamation-triangle" variant="warning" animation="throb" font-scale="8" />
            </template>
            <template v-else>
                <b-icon icon="files" variant="primary" animation="throb" font-scale="8" />
            </template>
       
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <template v-if="data.state !== undefined && data.state !== null">
            <p v-if="data.state == 2"> {{data.name}} {{$t('customer.list.cancelActMsg')}}</p>
            <p v-if="data.state ==1"> {{data.name}} {{$t('customer.list.activeActMsg')}}</p>
            <p v-if="data.state == 0"> {{data.name}} {{$t('customer.list.passifeActMsg')}}</p>
        </template>
        <template v-else>
            <p v-if="data.type == 'copy'">
             {{data.name}} {{$t('account.copyTextMsg')}}
            </p>
            <p v-if="data.type == 'part'">
             {{data.name}} {{$t('account.partTextMsg')}}
            </p>
        </template>

   </div>
</template>

<script>
    export default {
        name: "SetStateAccount",
        //
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalName: String,
            sendRequest: Function,

        },
        watch: {
            save: async function(data){
                if(data){
                    this.sendRequest()
                        
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/modals/SetState.vue